import { render } from "./msgCenter.vue?vue&type=template&id=7bbd27c1&scoped=true"
import script from "./msgCenter.vue?vue&type=script&lang=js"
export * from "./msgCenter.vue?vue&type=script&lang=js"

import "./msgCenter.vue?vue&type=style&index=0&id=7bbd27c1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbd27c1"]])

export default __exports__